import type { RouteRecordRaw } from "vue-router";

// Must match the tblMenuItem.MenuHrefOverride aliases of the Posts page (PageId 17), which all flip together.
const POST_TYPE_URL_SLUGS = ["news", "docs", "care-knowledge-base"] as const;

export const routes = [
  {
    path: `/:postTypeSlug(${POST_TYPE_URL_SLUGS.join("|")})/:pageArg1?/:pageArg2?`,
    name: "Posts",
    component: () => import("./postsPage.vue"),
    props: true,
  },
] satisfies RouteRecordRaw[];
